import type { ProcessableImage, ProcessableServerImage } from '../types/common.types'

/**
 * Server images reach us in two shapes: the hand-written `ProcessableServerImage` and the
 * generated `ImageResource`, which declares every field optional. `Partial` accepts both.
 *
 * See https://docs.metapic.dev/engineering/image-processing
 */
export const normalizeImage = (image: Partial<ProcessableServerImage>): ProcessableImage => ({
  key: image.key,
  baseUrl: image.base_url,
  contentType: image.content_type,
  url: image.url,
})
